import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  UserDetail,
  UserPlacementEnvironmentDetail,
} from "../../api/types/user";
import { useUser } from "../../api/queries/user/useUser";
import { Panel } from "primereact/panel";
import { none } from "../common";
import { useJourneyTypes } from "../../api/queries/enum/useJourneyTypes";
import { DataTable, DataTableRowClickEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

export default function UserDetailComponent() {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { data: userResponse } = useUser(uuid);
  const { data: journeyTypes } = useJourneyTypes();

  const [user, setUser] = useState<UserDetail | undefined>();

  const getContextName = (id: string) => {
    const context = journeyTypes?.data.results.find(
      (journeyType) => journeyType.id === id,
    );

    if (context) {
      return context.name;
    }

    return none;
  };

  const onPlacementEnvironmentRowClick = (row: DataTableRowClickEvent) =>
    navigate(`/journey-trackers/${row.data.results.placement_environment.id}`);

  const tName = (row: UserPlacementEnvironmentDetail) =>
    row.results.placement_environment.placement_environment_template
      ? row.results.placement_environment.placement_environment_template.name
      : row.results.placement_environment.name;

  const tDescription = (row: UserPlacementEnvironmentDetail) =>
    row.results.placement_environment.placement_environment_template
      ? row.results.placement_environment.placement_environment_template
          .description
      : none;

  const tContext = (row: UserPlacementEnvironmentDetail) =>
    row.results.placement_environment.journey_type.name;

  const tInstitutions = (row: UserPlacementEnvironmentDetail) =>
    row.results.institutions.map((institution) => institution.name).join(", ");

  const onNewPlacementEnvironmentClick = () =>
    navigate(`/users/${uuid}/journey-tracker`);

  useEffect(() => {
    if (userResponse) {
      setUser(userResponse.data);
    }
  }, [userResponse]);

  return (
    <div className="col-12">
      <Panel header="Personal information" toggleable={true} className="mb-3">
        <div>
          <strong>First name:</strong>{" "}
          {user?.personal_information.first_name || none}
        </div>
        <div>
          <strong>Last name:</strong>{" "}
          {user?.personal_information.last_name || none}
        </div>
        <div>
          <strong>E-mail:</strong> {user?.personal_information.email || none}
        </div>
        <div>
          <strong>Context:</strong>{" "}
          {user?.personal_information.context
            ? getContextName(user.personal_information.context.id)
            : none}
        </div>
        <div>
          <strong>Role:</strong> {user?.personal_information.roles.join(", ")}
        </div>
        <div>
          <strong>Needs:</strong> {user?.personal_information.needs || none}
        </div>
      </Panel>

      <Panel header="Journey Trackers" toggleable={true} className="mb-3">
        <div className="text-right">
          <Button
            label="Add new"
            className="p-button-sm p-button-main mb-3"
            onClick={onNewPlacementEnvironmentClick}
          />
        </div>

        <DataTable
          emptyMessage={"No records"}
          paginator={false}
          lazy={false}
          value={user?.placement_environments || []}
          className="p-datatable-sm p-datatable-pointer"
          onRowClick={onPlacementEnvironmentRowClick}
          stripedRows={true}
          rowHover={true}
        >
          <Column header={"Name"} body={tName} />

          <Column header={"Description"} body={tDescription} />

          <Column header={"Context"} body={tContext} />

          <Column header={"Institutions"} body={tInstitutions} />
        </DataTable>
      </Panel>
    </div>
  );
}
